<template>
<div class="chapter">
<div class="inner_page">
<h1>Dutch Oven Cooking</h1>
<div class="toc">
<p>
<b>Table of Contents</b>
</p>
<dl>
<dt>
<span class="chapter">
<a href="#/ch01">Introduction </a>
</span>
</dt>
<dt>
<span class="chapter">
<a href="#/ch02">Beginner</a>
</span>
</dt>
<dd>
<dl>
<dt>
<span class="bridgehead">
<a href="#/ch02#d0e106">Breads</a>
</span>
</dt>
<dt>
<span class="bridgehead">
<a href="#/ch02#d0e181">Sides</a>
</span>
</dt>
<dt>
<span class="bridgehead">
<a href="#/ch02#d0e304">Main Courses</a>
</span>
</dt>
<dt>
<span class="bridgehead">
<a href="#/ch02#d0e639">Desserts</a>
</span>
</dt>
</dl>
</dd>
<dt>
<span class="chapter">
<span href="#/ch03" title="Link target outside of Sample">Intermediate</span>
</span>
</dt>
<dd>
<dl>
<dt>
<span class="bridgehead">
<span href="#/ch03#d0e904" title="Link target outside of Sample">Breads</span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch03#d0e1011" title="Link target outside of Sample">Sides</span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch03#d0e1155" title="Link target outside of Sample">Main Courses</span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch03#d0e1613" title="Link target outside of Sample">Desserts</span>
</span>
</dt>
</dl>
</dd>
<dt>
<span class="chapter">
<span href="#/ch04" title="Link target outside of Sample">Advanced</span>
</span>
</dt>
<dd>
<dl>
<dt>
<span class="bridgehead">
<span href="#/ch04#d0e1915" title="Link target outside of Sample">Breads</span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch04#d0e2134" title="Link target outside of Sample">Main Courses</span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch04#d0e2480" title="Link target outside of Sample">Desserts</span>
</span>
</dt>
</dl>
</dd>
<dt>
<span class="chapter">
<span href="#/ch05" title="Link target outside of Sample">Our Author</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch06" title="Link target outside of Sample">Metric Conversion Chart</span>
</span>
</dt>
</dl>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// bk01-toc.vue?61bf4770